<script>
export default {
  name: 'UpTableColumn',
  props: {
    label: { type: String, default: '' },
    field: { type: String, default: '' },
    width: { type: [String, Number], default: '' },
    sortable: { type: Boolean, default: false }
  },
  inject: {
    registerColumn: { default: null },
    unregisterColumn: { default: null }
  },
  created() {
    if (this.registerColumn) this.registerColumn(this)
  },
  beforeDestroy() {
    if (this.unregisterColumn) this.unregisterColumn(this)
  },
  render() {
    return null
  }
}
</script>
